import apiClient from '@/services/axios'

export async function put(venueTask) {
  var response = await apiClient.put('/VenueTasks/', venueTask)
  if (response) {
    return response.data
  }

  throw new Error('Unable to update venue task.')
}